import { Input, InputProps } from '@chakra-ui/react';
import { AsYouType, CountryCode } from 'libphonenumber-js';
import { ChangeEvent } from 'react';
import { FieldValues, useFormContext } from 'react-hook-form';

import { SimpleField, SimpleXProps } from './SimpleField';

type SimpleInputProps<FormSchema extends FieldValues = FieldValues> = SimpleXProps<FormSchema> &
  InputProps & {
    country?: CountryCode;
  };

export const SimplePhoneNumberInput = <FormSchema extends FieldValues = FieldValues>({
  name,
  label,
  placeholder,
  helper,
  country,
  ...rest
}: SimpleInputProps<FormSchema>) => {
  const { setValue, register } = useFormContext();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const rawNumber = event.target.value;
    const formatter = new AsYouType(country);
    const formatted = formatter.input(rawNumber);
    // setValue expects some weird typings
    setValue(name, formatted as any);
  };

  return (
    <SimpleField name={name} label={label} helper={helper} {...rest}>
      <Input
        type="tel"
        inputMode="tel"
        variant="unstyled"
        placeholder={placeholder}
        {...register(name)}
        onChange={handleChange}
        _placeholder={{ color: 'text.placeholder' }}
      />
    </SimpleField>
  );
};
